import React, { useEffect, useState } from 'react';
import styles from './specificationsTab.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { getfilterproductcountThunk } from '../../../../redux/productSlice';
import { useNavigate } from 'react-router-dom';

const SpecificationsTab = ({ attributes, additionalResources, setSelectedAttributes, selectedAttributes, category,setSelectedCategory,selectedCategory }) => {
  const [activeTab, setActiveTab] = useState('specifications');
  const { productcount, filterloading } = useSelector(state => state.products)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const tabs = ['specifications', 'additionalResources'];




  const displayCategories = React.useMemo(() => {
    if (!category || !Array.isArray(category)) return [];

    const hasFixed = category.some(c => c?.name?.toLowerCase() === "fixed capacitors" || c?.name?.toLowerCase() === "fixed capacitor");
    if (!hasFixed) {
      const isCapacitorCategory = category.some(c => c?.name?.toLowerCase().includes("capacitor"));
      if (isCapacitorCategory) {
        const list = [...category];
        const capIdx = list.findIndex(c => c?.name?.toLowerCase() === "capacitors");
        const fixedObj = { _id: "Fixed Capacitors", name: "Fixed Capacitors" };
        if (capIdx !== -1) {
          list.splice(capIdx + 1, 0, fixedObj);
        } else {
          list.splice(1, 0, fixedObj);
        }
        return list;
      }
    }
    return category;
  }, [category]);

  const safeAttributes = attributes && typeof attributes === "object" ? attributes : {};

  // Attributes ticked for the product's level 3 in the admin: only these rows, in that order
  const chosenAttributes = React.useMemo(() => {
    const withChosen = (Array.isArray(category) ? category : []).filter(
      (c) => Array.isArray(c?.displayAttributes) && c.displayAttributes.length > 0
    );
    const level3 = withChosen.find((c) => c?.isCategory === false) || withChosen[0];
    return level3 ? [...new Set(level3.displayAttributes.map((a) => String(a || '').trim()).filter(Boolean))] : [];
  }, [category]);

  const hasAttributeValue = (value) =>
    value !== null && value !== undefined && !(Array.isArray(value) && value.length === 0) && String(value).trim() !== '' && String(value).trim() !== '-';

  // Only attributes that actually have a value are listed; blank ones are hidden.
  const specRows = (chosenAttributes.length
    ? chosenAttributes.map((name) => {
        const key = Object.keys(safeAttributes).find((k) => k.trim().toLowerCase() === name.toLowerCase());
        return [key || name, key ? safeAttributes[key] : null];
      })
    : Object.entries(safeAttributes)
  ).filter(([, value]) => hasAttributeValue(value));

  if (specRows.length === 0 && displayCategories.length === 0) {
    return <div style={{ padding: "20px", color: "#64748B", background: "#fff", borderRadius: "12px", border: "1px solid #E2E8F0" }}>No specifications available to display.</div>;
  }

  const handleCheckboxChange = (key, value) => {
    setSelectedAttributes((prev) => {
      const updatedAttributes = { ...prev };
      if (updatedAttributes[key]) {
        delete updatedAttributes[key]; // Uncheck: remove from selection
      } else {
        updatedAttributes[key] = value; // Check: add to selection
      }
      return updatedAttributes;
    });
  };

  // console.log("selectedAttributes", selectedAttributes);

  // Only send attributes the user explicitly selected. Sending every product
  // specification made the Similar Products page over-filter its own category.
  const transformed = Object.entries(selectedAttributes).map(([key, value]) => ({
    attribute: key,
    values: Array.isArray(value) ? value : [value]
  }));

  const data = {
    selectedCategory,
    selectedAttributes: transformed
  }

  return (
    <div className={styles.speccontainer}>
      {/* Tabs Section */}
      <div className={styles.spectabs}>
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`${styles.spectabButton} ${activeTab === tab ? styles.active : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === 'specifications' && 'Specifications'}
            {tab === 'additionalResources' && 'additionalResources'}
            {/* {tab === 'content' && 'Content'} */}
          </button>
        ))}
      </div>

      {/* Table Section */}
      {activeTab === 'specifications' && (
        <table className={styles.spectable}>
          <thead>
            <tr>
              <th>Product attribute</th>
              <th>Attribute value</th>
              <th></th>
            </tr>
          </thead>
          <tbody className={styles.spectbody}>
            <tr>
              <td className={styles.borderLeft}>Category</td>
              <td className={styles.borderLeft} style={{ justifyContent: 'space-between' }}>
                {
                  displayCategories?.map((i) => (
                    <div key={i._id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {i?.name}

                      <input
                        type="radio"
                        name="category"
                        value={i._id}
                        checked={selectedCategory === i._id}
                        onChange={() => setSelectedCategory(i._id)}
                      />
                    </div>

                  ))
                }
              </td>
            </tr>
            {specRows.map(([key, value]) => {
              const hasValue = value !== null && value !== undefined && !(Array.isArray(value) && value.length === 0) && String(value).trim() !== '';
              return (
                <tr key={key}>
                  <td className={styles.borderLeft}>{key}</td>
                  <td className={styles.borderRight}>{hasValue ? (Array.isArray(value) ? value.join(', ') : value) : '–'}</td>
                  <td className={styles.speccheck}>
                    {hasValue && (
                      <input
                        type="checkbox"
                        checked={!!selectedAttributes[key]}
                        onChange={() => handleCheckboxChange(key, value)}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {activeTab === 'additionalResources' && (
        <table className={styles.spectable}>
          <thead>
            <tr>
              <th>Product attribute</th>
              <th>Attribute value</th>
              <th></th>
            </tr>
          </thead>
          <tbody className={styles.spectbody}>
            {Object.entries(additionalResources || {}).filter(([, value]) => hasAttributeValue(value)).map(([key, value]) => (
              <tr key={key}>
                <td className={styles.borderLeft}>{key}</td>
                <td className={styles.borderRight}>{value}</td>
                {/* <td className={styles.speccheck}>
                  <input type="checkbox" />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className={styles.displayFlex} style={{ marginTop: "20px" }}>
        {
          filterloading &&
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10 }}>
            <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
          </div>
        }
        {typeof productcount === 'number' && <p style={{ color: '#666666' }}>{productcount} items remaining</p>}
        <button className={styles.submitBtn} onClick={() => navigate('/SimilarProductList', { state: data })}>View similar</button>
      </div>


    </div>
  );
};

export default SpecificationsTab;
